<img src="{{ imageUrl() }}" alt="" (click)="clickOnImage.emit()">
